import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton, ModalProps,
  Typography
} from '@mui/material';
import React from 'react';
import { useTheme } from '@mui/material/styles';
import { FlexBox, FlexBoxFullWidth } from './boxes';
import { Close } from '@mui/icons-material';
import { keyboard } from '@testing-library/user-event/dist/keyboard';

export interface IModalProps {
  onClose: () => void,
  open?: boolean,
  children: React.ReactNode,
  headerIcon?: React.ReactNode,
  title?: string,
  withDividers?: boolean,
  dialogActions?: React.ReactNode,
  maxWidth?: number | string,
  minWidth?: number | string,
  height?: number | string,
  minHeight?: number | string,
  keepMounted?: boolean;
}

export const Modal: React.FC<IModalProps> =
  ({
     onClose,
     open = true,
     children,
     headerIcon,
     title = '',
     withDividers = true,
     dialogActions,
     maxWidth,
     minWidth,
     height,
     minHeight,
     keepMounted
   }) => {
    const theme = useTheme();
    return (
      <Dialog open={open} keepMounted={keepMounted} onClose={onClose} PaperProps={{
        style: {
          borderRadius: 8,
          padding: theme.breakpoints.down('laptop')
            ? theme.spacing(0)
            : theme.spacing(0, 4, 4, 4),
          position: 'relative',
          overflow: 'hidden',
          backgroundColor: theme.palette.background.default,
          width: theme.breakpoints.down('laptop') ? '90vw' : '75vw',
          maxWidth,
          minWidth,
          margin: 0,
          height,
          minHeight
        }
      }}>
        <DialogTitle sx={{ m: 0, p: 2, minHeight: 50 }}>
          <FlexBoxFullWidth justifyContent={'space-between'} alignItems={'center'} position={'relative'}>
            <FlexBox alignItems={'start'}>
              {
                headerIcon &&
                <Box mr={2}>
                  {headerIcon}
                </Box>
              }
              <Typography variant={'h4'}>
                {title}
              </Typography>
            </FlexBox>
            <IconButton onClick={onClose}>
              <Close/>
            </IconButton>
          </FlexBoxFullWidth>
        </DialogTitle>

        <DialogContent dividers={withDividers} sx={{ padding: { laptop: 4, mobile: 2 } }}>
          {children}
        </DialogContent>
        {
          dialogActions &&
          <DialogActions>
            {dialogActions}
          </DialogActions>
        }
      </Dialog>
    );
  };